import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { FaBan } from "react-icons/fa";
import { useTheme } from "../../context/ThemeContext";

import { Icon } from "../../components/common/Icon";

const ForbiddenPage: React.FC = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const isDark = theme === "dark";

    return (
        <div className="error-page">
            <Container className="text-center">
                <div className="icon-wrapper">
                    <Icon icon={FaBan} className="error-icon" />
                </div>
                <h1 className="error-title">Access Denied</h1>
                <p className="error-message">
                    You don't have permission to access this page.
                    <br />
                    Please contact your administrator if you believe this is a mistake.
                </p>
                <Button
                    variant="primary"
                    className="action-btn"
                    onClick={() => navigate("/dashboard")}
                >
                    Back to Dashboard
                </Button>
            </Container>

            <style>{`
        .error-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${isDark ? "#0f172a" : "#f8fafc"};
          color: ${isDark ? "#f8fafc" : "#0f172a"};
        }

        .icon-wrapper {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: ${isDark ? "rgba(239, 68, 68, 0.1)" : "#fee2e2"};
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
        }

        .error-icon {
          font-size: 3rem;
          color: ${isDark ? "#f87171" : "#dc2626"};
        }

        .error-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, #f87171 0%, #dc2626 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .error-message {
          font-size: 1.1rem;
          color: ${isDark ? "#94a3b8" : "#64748b"};
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .action-btn {
          padding: 0.75rem 2rem;
          border-radius: 12px;
          font-weight: 600;
          background: linear-gradient(135deg, #f87171 0%, #dc2626 100%);
          border: none;
          box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
          transition: all 0.3s ease;
        }

        .action-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(220, 38, 38, 0.4);
        }
      `}</style>
        </div>
    );
};

export default ForbiddenPage;
